<template>
  <div :id="this.$route.name">
    <form @submit.prevent="this.$ValidForm(this)">
      <div class="card text-center">
        <div class="card-header" :class="ThemeTitleModal">
          <ul
            class="nav nav-tabs mt-3 card-header-tabs"
            id="myTab"
            role="tablist"
            dir="rtl"
          >
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Detail-tab"
                data-toggle="tab"
                href="#Detailtab"
                role="tab"
                aria-controls="Detailtab"
                aria-selected="true"
                >تعریف سمت ها</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                @click.prevent="LoadDataOneToMeny"
                id="InformationSystem-tab"
                data-toggle="tab"
                href="#InformationSystem"
                role="tab"
                aria-controls="InformationSystem"
                aria-selected="true"
                >سیستم های اطلاعاتی</a
              >
            </li>
          </ul>
        </div>
        <div class="tab-content" id="Controler">
          <div
            class="tab-pane fade show active"
            id="Detailtab"
            role="tabpanel"
            aria-labelledby="Detail-tab"
          >
            <div id="Controler">
              <div class="container mt-3 mb-3 text-right">
                <div class="row">
                  <div class="col-lg-3 col-12">
                    <small id="LblGcode">کد سمت</small>
                    <input
                      @keypress="$ValidNumber($event, 9)"
                      type="text"
                      class="form-control InputText"
                      v-model="DataAxios.Gcode"
                    />
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <small id="LblGName">نام سمت</small>
                    <input
                      @keypress="$ValidPersian($event, 45)"
                      type="text"
                      class="form-control InputText"
                      v-model="DataAxios.GName"
                    />
                  </div>
                  <div class="col-lg-5 col-12 text-right">
                    <small id="LblParentId">مدیر</small>
                    <select class="form-control" v-model="Modir">
                      <option value="-1">
                        <span> انتخاب مدیر</span>
                      </option>
                      <option
                        v-for="item in this.$store.state.TarifSematha
                          .treeSemathaFlat"
                        :key="item.id"
                        :value="item.id"
                      >
                        <span :value="item.id">{{ item.GName }}</span>
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <small id="LblTozihat">توضیحات</small>
                    <textarea
                      @keypress="$ValidPersian($event, 95)"
                      type="text"
                      class="form-control"
                      rows="2"
                      v-model="DataAxios.Tozihat"
                    ></textarea>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4 col-12">
                    <small id="LblIsModirShoab"
                      >مدیر کل شعب (بالاترین سطح دسترسی)</small
                    >
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="IsModirShoab"
                          @click="statusChk($event)"
                          v-model="IsModir"
                        />
                        <label class="custom-control-label" for="IsModirShoab"
                          >مدیر کل شعب</label
                        >
                      </div>
                    </span>
                  </div>
                  <div class="col-md-8 col-12">
                    <small id="LblNameShobe">نام شعبه</small>
                    <select class="form-control required" v-model="Shobe">
                      <option value="-1">نام شعبه را انتخاب کنید</option>
                      <option
                        v-for="item in this.$store.state.TarifSematha.Listshobe"
                        :key="item.Id"
                        :value="item.Id"
                      >
                        {{ item.NameShobe }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <button-edit-data
              class="mb-3 mr-2"
              :DataParanet="DataAxios"
            ></button-edit-data>
          </div>
          <div
            class="tab-pane fade show"
            id="InformationSystem"
            role="tabpanel"
            aria-labelledby="InformationSystem-tab"
          >
            <div class="alert alert-secondary mt-2 mb-2 text">
              <span> مدیریت سیستم های اطلاعاتی به سمت </span>
              <span class="text-danger font-weight-bold">
                [ {{ DataAxios.GName }} ]
              </span>
              <span> به کد سمت </span>
              <span class="text-danger font-weight-bold">
                [ {{ DataAxios.Gcode }} ]
              </span>
            </div>
            <div class="row mt-3">
              <div class="col-md-9 col-12">
                <select
                  id="GrpDb"
                  class="form-control mt-2 mb-4"
                  v-model="GrpDbModel"
                >
                  <option value="-1">
                    <span>سیستم اطلاعاتی برای سمت مورد نظر انتخاب کنید</span>
                  </option>
                  <option
                    :value="item.Id"
                    v-for="item in this.$store.state.TarifSematha.RowsGridGrpDb"
                    :id="item.Id"
                    :key="item.Id"
                  >
                    <span>{{ item.Dbname }}</span>
                  </option>
                </select>
              </div>
              <div class="col-md-3 col-12">
                <div
                  class="mt-2 mb-3 text-right animate__animated animate__fadeInDown"
                >
                  <button
                    id="SeveData"
                    type="submit"
                    class="btn btn-success mr-1"
                    dir="ltr"
                    @click.prevent="SetDeta"
                  >
                    <span class="mr-2"> ثبت اطلاعات </span>
                    <span class="fa fa fa-check"></span>
                  </button>
                </div>
              </div>
            </div>
            <assign-grid
              v-if="this.$store.state.renderComponentGridOneToMeny"
              :Data="DataAxios"
              :ParentPage="'Edit'"
            ></assign-grid>
          </div>
        </div>

        <div v-for="Dataa in EditData" :key="Dataa.id"></div>
      </div>
    </form>
  </div>
</template>
<script>
import ButtonEditData from "../Tools/ButtonEditData.vue";
import AssignGrid from "../Tools/AssignGrid.vue";
export default {
  components: {
    ButtonEditData,
    AssignGrid,
  },
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: {},
        Method: "Get",
        Action: "DastresiDB/GettblDB",
        Token: this.$session.get("Token"),
      },
      DataAxoisAddTblGrpDb: {
        ArryfildValue: {},
        Method: "post",
        Action: "DastresiDB",
        Token: this.$session.get("Token"),
      },
      DataAxoisCheckedIdDb: {
        ArryfildValue: {},
        Method: "Get",
        Action: "DastresiDB",
        Token: this.$session.get("Token"),
        From: "Header",
      },
      EditData: this.$store.state.TarifSematha.EditData,
      DataAxios: null,
      RowsGridGrpDb: null,
      DataGrpDb: null,
    };
  },
  computed: {
    GrpDbModel: {
      get() {
        return this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblDbid;
      },
      set(value) {
        this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblDbid = value;
      },
    },
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    Modir: {
      get() {
        return this.DataAxios.ParentId;
      },
      set(value) {
        if (value != -1) {
          this.DataAxios.ParentId = value;
        } else {
          this.DataAxios.ParentId = null;
        }
      },
    },
    Shobe: {
      get() {
        return this.$store.state.TarifSematha.EditData[0].TblShobeId;
      },
      set(value) {
        this.$store.state.TarifSematha.EditData[0].TblShobeId = value;
      },
    },
    IsModir: {
      get() {
        return this.$store.state.TarifSematha.EditData[0].IsModirShoab;
      },
      set(value) {
        this.$store.state.TarifSematha.EditData[0].IsModirShoab = value;
      },
    },
  },
  methods: {
    SetDeta() {
      var DataGrpDb = this.$store.state.TarifSematha.DataGrpDb;
      var DbForAdd = this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblDbid;
      // console.log(DataGrpDb);
      // console.log(DbForAdd);
      if (DataGrpDb.length > 0) {
        for (let index = 0; index < DataGrpDb.length; index++) {
          if (
            DataGrpDb[index].TblDbid == DbForAdd ||
            this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblDbid == -1
          ) {
            this.$mySweetDefault(
              "عدم امکان ثبت سیستم اطلاعاتی انتخاب شده",
              "سیستم اطلاعاتی انتخاب شده ، قبلا برای این سمت ثبت گردیده",
              "warning",
              3000
            );
          } else {
            this.DataAxoisAddTblGrpDb.ArryfildValue =
              this.$store.state.TarifSematha.DataPostTblGrpDb[0];
            this.$PostData(this.DataAxoisAddTblGrpDb).finally(() => {
              this.$mySweetDefaultTost(
                false,
                "بارگزاری یا موفقیت انجام شد",
                "success",
                2000
              );
              this.$store.state.renderComponent = false;
              this.$store.state.renderComponentGridOneToMeny = false;
              this.$nextTick(() => {
                this.$store.state.renderComponent = true;
                this.$store.state.renderComponentGridOneToMeny = true;
              });
            });
          }
        }
      } else {
        this.DataAxoisAddTblGrpDb.ArryfildValue =
          this.$store.state.TarifSematha.DataPostTblGrpDb[0];
        this.$PostData(this.DataAxoisAddTblGrpDb).finally(() => {
          this.$mySweetDefaultTost(
            false,
            "بارگزاری یا موفقیت انجام شد",
            "success",
            2000
          );
          this.$store.state.renderComponent = false;
          this.$store.state.renderComponentGridOneToMeny = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
            this.$store.state.renderComponentGridOneToMeny = true;
          });
        });
      }
    },
    statusChk: function (event) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "IsModirShoab") {
        if (checkBox.checked == true) {
          this.$store.state.TarifSematha.EditData[0].IsModirShoab = true;
        } else {
          this.$store.state.TarifSematha.EditData[0].IsModirShoab = false;
        }
      }
    },
    LoadDataOneToMeny() {
      // this.$GetData_Header(this.DataAxoisCheckedIdDb).then((data) => {
      //       this.DataGrpDb=data
      //     }).finally(()=>{
      //         this.$store.state.TarifSematha.DataGrpDb=this.DataGrpDb
      //     });
    },
  },
  mounted() {
    this.$GetData_Body(this.DataAxiosRow)
      .then((data) => {
        this.RowsGridGrpDb = data;
      })
      .finally(() => {
        this.$store.state.TarifSematha.RowsGridGrpDb = this.RowsGridGrpDb;
        // this.$mySweetDefaultTost(false,'بارگزاری اطلاعات موفقیت آمیز بود','success',500);
      });

    this.DataAxoisCheckedIdDb.ArryfildValue["Id"] =
      this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblGrpId;

    this.$GetData_Header(this.DataAxoisCheckedIdDb)
      .then((data) => {
        this.DataGrpDb = data;
      })
      .finally(() => {
        this.$store.state.TarifSematha.DataGrpDb = this.DataGrpDb;
      });
    // console.log("Grid");
    // console.log(this.$store.state.TarifSematha.DataGrpDb);
  },
  beforeMount() {
    let info;
    let list = [];
    if (this.EditData.length > 0) {
      for (let index = 0; index < this.EditData.length; index++) {
        info = this.EditData[index];
        for (const key of Object.keys(info)) {
          info[key] =
            typeof info[key] == "string" ? info[key].trim() : info[key];
        }
        list.push(info);
      }
      this.DataAxios = list[0];
      this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios);
    }
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
</style>
